import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'autoBidButtonText',
  pure: false,
  standalone: true
})
export class AutoBidButtonTextPipe implements PipeTransform {
  btnGrp : any;
  constructor(private readonly translocoService:TranslocoService){
    this.translocoService.selectTranslateObject('vehicles.auctionDetails.btnBidGrp').subscribe(value =>{
      this.btnGrp = {
        bid : value.btnBid,
        updateBid : value.btnUpdateBid
      };
    });
  }

  transform(value: string): string {
    switch (value) {
    case 'PENDING':
    case 'OPEN': {
      return this.btnGrp.updateBid;
    }
    default: {
      return this.btnGrp.bid;
    }
    }
  }
}
